import type { LiveOrganizationService, NormalizeOrganizationServiceFromApiParams } from '../types';
import normalizeOrganizationServiceActorFromApi from './normalizeOrganizationServiceActorFromApi';
import normalizeOrganizationServiceBillingFromApi from './normalizeOrganizationServiceBillingFromApi';
import normalizeOrganizationServiceSourceFromApi from './normalizeOrganizationServiceSourceFromApi';
import throwUnsupportedOrganizationService from './throwUnsupportedOrganizationService';

const normalizeOrganizationServiceFromApi = ({
    dto,
}: NormalizeOrganizationServiceFromApiParams): LiveOrganizationService => {
    if (dto.status !== 'active' && dto.status !== 'archived') {
        return throwUnsupportedOrganizationService({});
    }

    if (typeof dto.schemaVersion !== 'number' || typeof dto.revision !== 'number') {
        return throwUnsupportedOrganizationService({});
    }

    if (
        typeof dto.workflowCount !== 'number' ||
        !Number.isInteger(dto.workflowCount) ||
        dto.workflowCount < 0
    ) {
        return throwUnsupportedOrganizationService({});
    }

    if (
        typeof dto.promptCount !== 'number' ||
        !Number.isInteger(dto.promptCount) ||
        dto.promptCount < 0
    ) {
        return throwUnsupportedOrganizationService({});
    }

    const archivedBy =
        dto.archivedBy === null
            ? null
            : normalizeOrganizationServiceActorFromApi({ actor: dto.archivedBy });

    return {
        id: dto.id,
        schemaVersion: dto.schemaVersion,
        revision: dto.revision,
        organizationId: dto.organizationId,
        serviceBlueprintId: dto.serviceBlueprintId,
        sourceBlueprintRevision: dto.sourceBlueprintRevision,
        name: dto.name,
        description: dto.description,
        iconName: dto.iconName,
        billingAtAssignment: normalizeOrganizationServiceBillingFromApi({
            billing: dto.billingAtAssignment,
        }),
        billing: normalizeOrganizationServiceBillingFromApi({ billing: dto.billing }),
        requirementsMarkdown: dto.requirementsMarkdown,
        status: dto.status,
        archivedBy,
        archivedAt: dto.archivedAt,
        evidenceCount: dto.evidenceCount,
        workflowCount: dto.workflowCount,
        promptCount: dto.promptCount,
        assignedBy: normalizeOrganizationServiceActorFromApi({ actor: dto.assignedBy }),
        createdBy: normalizeOrganizationServiceActorFromApi({ actor: dto.createdBy }),
        updatedBy: normalizeOrganizationServiceActorFromApi({ actor: dto.updatedBy }),
        assignedAt: dto.assignedAt,
        createdAt: dto.createdAt,
        updatedAt: dto.updatedAt,
        source: normalizeOrganizationServiceSourceFromApi({ source: dto.source }),
    };
};

export default normalizeOrganizationServiceFromApi;
